/**
 * Server-aligned clock. Edit times decide which concurrent change is newer,
 * so we correct for a device clock that is off by learning the offset from
 * each sync response.
 */
let offsetMs = 0;

export function clientNow(): number {
  return Date.now() + offsetMs;
}

export function learnServerTime(serverTime: number) {
  offsetMs = serverTime - Date.now();
}
